import { render, staticRenderFns } from "./documents-list.vue?vue&type=template&id=3fef0464&scoped=true&"
import script from "./documents-list.vue?vue&type=script&lang=js&"
export * from "./documents-list.vue?vue&type=script&lang=js&"
import style0 from "./documents-list.vue?vue&type=style&index=0&id=3fef0464&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fef0464",
  null
  
)

component.options.__file = "documents-list.vue"
export default component.exports